var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card 1",
    clipPath: "url(#clip0_12270_190165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.3125 13.125C7.83203 13.125 8.25 13.543 8.25 14.0625C8.25 14.582 7.83203 15 7.3125 15H5.4375C4.91797 15 4.5 14.582 4.5 14.0625C4.5 13.543 4.91797 13.125 5.4375 13.125H7.3125ZM14.8125 13.125C15.332 13.125 15.75 13.543 15.75 14.0625C15.75 14.582 15.332 15 14.8125 15H10.4375C9.91797 15 9.5 14.582 9.5 14.0625C9.5 13.543 9.91797 13.125 10.4375 13.125H14.8125ZM20.75 1.25C22.1289 1.25 23.25 2.36914 23.25 3.75V16.25C23.25 17.6289 22.1289 18.75 20.75 18.75H3.25C1.86914 18.75 0.75 17.6289 0.75 16.25V3.75C0.75 2.36914 1.86914 1.25 3.25 1.25H20.75ZM20.75 3.125H3.25C2.90469 3.125 2.625 3.40469 2.625 3.75V5H21.375V3.75C21.375 3.40469 21.0938 3.125 20.75 3.125ZM21.375 8.75H2.625V16.25C2.625 16.5938 2.90469 16.875 3.25 16.875H20.75C21.0938 16.875 21.375 16.5938 21.375 16.25V8.75Z",
    fill: "#9C9C9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12270_190165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCreditCard);
export default __webpack_public_path__ + "static/media/default-credit-card.5cb742c72c3cfd7678c31e5fdc15b5fc.svg";
export { ForwardRef as ReactComponent };